export class Report {
	constructor() {
	}
} 
